import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ภาษีหัก ณ ที่จ่าย (WHT) — ยื่น ภ.ง.ด.3/53/54 ภายในวันที่ 7","metaTitle":"ยื่นภาษีหัก ณ ที่จ่าย WHT ภ.ง.ด.3/53/54 | NYC","metaDesc":"บริการยื่นภาษีหัก ณ ที่จ่าย (WHT) ภ.ง.ด.3, 53, 54 ภายในวันที่ 7 ของเดือนถัดไป ครอบคลุมค่าบริการ ค่าเช่า ค่าลิขสิทธิ์ Withholding tax Thailand"},"en":{"h1":"Thai Withholding Tax (WHT) — PND 3/53/54 filing by the 7th","metaTitle":"Withholding Tax Thailand — PND 3/53/54 Monthly Filing | NYC","metaDesc":"Monthly Thai Withholding Tax filing (PND 3, 53, 54) by the 7th (15th e-filing). Covers services, rent, royalties, and cross-border payments with DTA relief."}} as const;

export const Route = createFileRoute("/tax/withholding")({
  head: () => {
    const url = `${SEO_SITE}/tax/withholding`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/tax/withholding", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/tax/withholding", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/tax/withholding", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/tax/withholding", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/tax/withholding", "/en/tax/withholding")],
    };
  },
  component: () => <SubServicePage slug="tax/withholding" locale="th" />,
});
